import React, { useState, useEffect } from 'react';
import './MyCoupon.css';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';

function MyCoupon() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
const [userData, setUserData] = useState(null);
const [showUsed, setShowUsed] = useState(false); 
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

const [availableCoupons, setAvailableCoupons] = useState([]);
const [usedCoupons, setUsedCoupons] = useState([]);

const [isLoading, setIsLoading] = useState(false);
const [showMenu, setShowMenu] = useState(false);

const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);

useEffect(() => {
  const loadCoupons = async () => {
    setIsLoading(true);
    await fetchCoupons();  // ← ไม่ต้องใส่ true/false แล้ว
    setIsLoading(false);
  };

  loadCoupons();
}, []);


const fetchCoupons = async () => {
  try {
    const res = await fetch(
      `${CONFIG.API_BASE_URL}/coupon/user_coupon?line_user_id=${localStorage.getItem('line_user_id')}&page=1&limit=1000`
    );
    const result = await res.json();

    const allDetailsRes = await fetch(`${CONFIG.API_BASE_URL}/coupon/?page=1&limit=1000`);
    const allDetails = await allDetailsRes.json();
    const detailMap = {};
    allDetails?.content?.data?.forEach(coupon => {
      detailMap[coupon.id] = coupon;
    });

    if (result?.content?.data) {
      const enriched = result.content.data.map((coupon) => {
        const detail = detailMap[coupon.coupon_id] || {};
        return {
          ...coupon,
          name: detail.name || '',
          description: detail.short_description || '',
          description_en: detail.short_description_en || '',
          name_en: detail.name_en || '',
          point_cost: detail.point_cost,
          expired_at: coupon.expired_at,
          image_url: detail.image_url,
          expired: !coupon.used ? new Date() > new Date(coupon.expired_at) : false
        };
      });

      setUsedCoupons(enriched.filter(c => c.used || c.expired));
      setAvailableCoupons(enriched.filter(c => !(c.used || c.expired)));
    }
  } catch (err) {
    console.error("Error fetching coupons:", err);
  }
};



useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>

         {isLoading && (
  <div className="full-screen-spinner">
    <div className="spinner" />
  </div>
)}

      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>

    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>


   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.my_coupon.my_coupon}</span>
</div>

<div className="coupon-header-info">
  <div className="user-id-section">
    <img src="/assets/cloud.png" alt="cloud" className="cloud-icon" />
    <span className="user-id">UF{userData?.phone || 'XXXXXXX'}</span>
  </div>
  <button className="redeem-point-button" onClick={() => navigate('/point-redeem')}>
    <img src="/assets/rewarded_ads-white.png" alt="redeem" style={{width: '20px', height: '20px'}} />
    {t.my_coupon.redeem}
  </button>
</div>

  <div className="coupon-tab-toggle">
        <button className={`tab-button ${!showUsed ? 'active' : ''}`} onClick={() => setShowUsed(false)}>{t.my_coupon.available_coupon}</button>
        <button className={`tab-button ${showUsed ? 'active' : ''}`} onClick={() => setShowUsed(true)}>{t.my_coupon.used_coupon}</button>
      </div>

<div className="coupon-list">
  {(showUsed ? usedCoupons : availableCoupons).map((coupon) => (
    <div className={`coupon-card ${showUsed ? 'used-coupon' : ''}`} key={coupon.id}>
      <div className="coupon-image-placeholder">
        <img src={coupon.image_url} alt={coupon.name} className="coupon-main-image" />
        {
          coupon.expired ? <img src="/assets/expired.svg" alt="expired" className="postponed-stamp" /> :
          coupon.used && <img src="/assets/redeemed.svg" alt="redeemed" className="postponed-stamp" />}
        {}
      </div>
      <div className="coupon-detail">
        <h4 className="coupon-title-mycoupon"> 
          {language === 'EN' ? coupon.name_en : coupon.name}
        </h4>
        <p className="coupon-subtitle">
          {language === 'EN' ? coupon.description_en : coupon.description}
        </p>
        <button
          onClick={() =>
            navigate('/coupon-use?coupon_id=' + coupon.coupon_id + '&user_coupon_id=' + coupon.id)
          }
          className="use-coupon-button"
          disabled={showUsed}
        >
          {t.my_coupon.used_coupon}
        </button>
      </div>
    </div>
  ))}
</div>
    </div>
  );
}

export default MyCoupon;
